<template>
    <div class="ku-apply">
        <van-row class="content">
            <van-col span="24">
                <van-field class="s2" readonly v-model.trim="row.cust_addr" name="地址" placeholder="请选择门店地址" >
                    <template #button>
                        <van-button size="small" class="ku-addr-btn" @click="onShowMap" type="primary">选择地址</van-button>
                    </template>
                </van-field>
            </van-col>
            <van-col span="24"><van-field v-model.trim="row.shop_name" placeholder="店铺名" /></van-col>
        </van-row>
        <van-row class="content">
            <van-col class="bank_acct" span="24">
                <span>账户类型：</span>
                <van-radio-group v-model="row.bank_acct_type" direction="horizontal">
                    <van-radio name="1">对公</van-radio>
                    <van-radio name="2">对私(法人)</van-radio>
                </van-radio-group>
            </van-col>
            <van-col span="8"><van-field v-model.trim="row.cont_name" placeholder="持卡人姓名" /></van-col>
            <van-col span="16"><van-field v-model.trim="row.card_id_mask" placeholder="结算银行卡号" /></van-col>
            <van-col span="8"><van-field v-model.trim="row.mobile" placeholder="登录电话" /></van-col>
            <van-col span="16"><van-field v-model.trim="row.legal_idno" placeholder="身份证号" /></van-col>
            <van-col class="ku-upload" span="24">
                <van-uploader :after-read="image1_afterRead" v-model="image1" upload-text="营业执照" :max-count="1" :max-size="2 * 1024 * 1024" />
                <van-uploader :after-read="image2_afterRead" v-model="image2" upload-text="食品经营许可证" :max-count="1" :max-size="2 * 1024 * 1024"/>
                <van-uploader :after-read="image3_afterRead" v-model="image3" upload-text="店铺正面照片" :max-count="1" :max-size="2 * 1024 * 1024" />
            </van-col>
        </van-row>

        <van-checkbox v-model="row.checked" class="checked">
            同意并接受<a @click.stop="about(1)">《用户协议》</a>和<a @click.stop="about(2)">《隐私协议》</a>
        </van-checkbox>

        <van-popup
            v-model="show_1"
            closeable
            class="popup"
            close-icon="close"
            position="bottom"
            :style="{ height: '70%', textAlign: 'left', padding: '20px 0 0 0' }"
        >
            <div class="popup-content" v-html="about_1"></div>
        </van-popup>
        <van-popup
            v-model="show_2"
            closeable
            class="popup"
            position="bottom"
            :style="{ height: '70%', textAlign: 'left', padding: '20px 0 0 0' }"
        >
            <div class="popup-content" v-html="about_2"></div>
        </van-popup>

        <!-- 弹出地图选择(这里用的也是vant的弹出组件) -->
        <van-popup v-model="showMap" position="right" :style="{ height: '100%',width:'100%' }">
            <qq-map :map-key="mapKey" :key-name="keyName" @callback="callback" @hideMap="showMap = false"></qq-map>
            <!--               :lat="settings.store_latitude"
              :lng="settings.store_longitude" -->
        </van-popup>

        <div class="but-submit">
            <van-button round plain type="warning" @click="onSubmit" native-type="submit">提交</van-button>
        </div>

    </div>
</template>

<script>

import Vue from 'vue';
import {Field, Button, Dialog, Uploader, Popup, Checkbox, CheckboxGroup, Col, Row, Area, Picker, RadioGroup, Radio} from 'vant';

import QqMap from '@/components/Qqmap'
import {getCookie, setCookie} from "@/utils/auth";
import {areaList} from "@vant/area-data";

Vue.use(Field).use(Button).use(Dialog).use(Popup).use(Col).use(Row)
    .use(Checkbox).use(CheckboxGroup).use(Uploader).use(Area).use(Picker)
    .use(RadioGroup).use(Radio);

export default {
    name: "Apply",
    components: {
        QqMap
    },
    data() {
        return {
            id: 0,
            type: 1,
            name: '',            // 店铺名称
            image1: [], // 营业执照
            image2: [], // 食品经营许可证
            image3: [], // 店铺门头照片
            code: '',
            address_info: {},

            show: true,
            count: '',
            timer: null,

            about_1: '',
            about_2: '',
            show_1: false,
            show_2: false,

            showMap: false,
            mapKey: 'PYZBZ-3MLC5-5XCIM-QOCQI-GI5UJ-S4F23',
            keyName: 'kupeng',

            bank_name: '',
            bank_1: '',
            bank_2: '',

            row: {
                shop_name: '',
                cust_addr: '',
                cont_name: '',
                card_id_mask: '',
                mobile: '',
                legal_idno: '',
                bank_acct_type: '2',
                address_info: {},
                license_img: '',
                permit_img: '',
                shop_img: '',
                address_latitude: '',
                address_longitude: '',
                area_info_detail: '',
                address_detail: '',
                checked: false,      // 注册协议
            }
        }
    },
    mounted() {
        this.onLoad()
    },
    watch: {
        row: {
            handler(val) {
                setCookie('shop_apply', JSON.stringify(val));
            },
            deep: true
        }
    },
    methods: {
        onLoad() {
            let that = this
            let query = this.$route.query // 获取路径上的参数
            console.log('data', query)
            this.id = query.id || 0
            if (query.id) {
                this.$API.applyInfo({id: query.id}).then(res => {
                    var data = res.data;
                    if (data.to_status === 1) {
                        Dialog.confirm({
                            message: '店铺等待审核中',
                            showCancelButton: false
                        }).then(
                            that.$router.push('/')
                        )
                    } else if (data.to_status === 2) {
                        Dialog.confirm({
                            message: '店铺已通过审核，无需重新提交',
                            showCancelButton: false
                        }).then(
                            that.$router.push('/')
                        )
                    } else {
                        that.row = data
                    }
                })
            } else {
                let old = getCookie('shop_apply')
                if (old) {
                    this.row = JSON.parse(old)
                }
                // 新申请默认对私（含本地草稿）
                this.row.bank_acct_type = '2'
            }

            this.$API.getAbout({type: 3}).then(res => {
                this.about_1 = res.data.content
            })
            this.$API.getAbout({type: 2}).then(res => {
                this.about_2 = res.data.content
            })

            if (query.module) {
                let lat_lng = query.latng.split(",") // 获取经纬度
                let reg = /.+?(省|市|自治区|自治州|县|区)/g // 省市区的正则

                let addr = query.addr.match(reg)
                this.callback(lat_lng, addr, query)
            }
        },
        onShowMap() {
            // Stay on current page (home empty-apply or /apply). Do not history.back().
            const back = encodeURIComponent(window.location.href)
            window.location.href = `https://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl=${back}&key=${this.mapKey}&referer=${this.keyName}`
        },
        validator() {
            console.log('row', this.row)
            if (!this.row.checked) {
                Dialog.alert({message: '请同意并接受服务协议'})
                return false
            }
            if (!this.row.shop_name.length) {
                Dialog.alert({message: '请输入店铺名称'})
                return false;
            }
            if (!this.row.address_longitude || !this.row.address_latitude) {
                Dialog.alert({message: '请选择店铺位置'})
                return false;
            }
            if (!/^1[3-9]\d{9}$/.test(this.row.mobile)) {
                Dialog.alert({message: '请输入正确手机号'})
                return false
            }
            return true
        },
        onSubmit() {
            let _this = this
            if (this.validator()) {
                this.$API.applyNew(_this.row).then(res => {
                    if (res.code === 1) {
                        this.$router.push("/apply_success")
                    }
                })
            }
        },
        image1_afterRead(file, detail) {
            this.afterRead(file, detail, 'license_img')
        },
        image2_afterRead(file, detail) {
            this.afterRead(file, detail, 'permit_img')
        },
        image3_afterRead(file, detail) {
            this.afterRead(file, detail, 'shop_img')
        },
        afterRead(file, detail, item) {
            file.status = 'uploading';
            file.message = '上传中...';

            let formData = new FormData();
            formData.append("file", file.file);

            this.$API.upload(formData).then(res => {
                file.status = 'done'
                this.row[item] = res.data.url
            }).catch(res => {
                file.status = 'failed'
                file.message = '上传失败'
                console.log(res)
            })
        },

        // 地图选择回调
        callback(lat_lng, areaArr, query) {
            this.row.address_latitude = lat_lng[0]
            this.row.address_longitude = lat_lng[1]

            let addr = query.addr
            areaArr.forEach(item => {
                let reg = new RegExp(item);
                addr = addr.replace(reg, "");
            });

            this.row.cust_addr = addr // 存储地图选择的详细地址
        },

        about(type) {
            if (type === 1) {
                this.show_1 = true
            }
            if (type === 2) {
                this.show_2 = true
            }
        },
    },
}
</script>

<style scoped lang="less">
@import "/src/styles/base";
.ku-apply {
    padding: 30px 40px 40px;
    min-height: 100%;

    .content {
        display: block;
        .van-col {
            padding: 3px;
        }
        .van-field {
            padding: 15px 10px;
        }
        .van-cell {
        }
        .s2 {
            padding: 7px 10px;
        }

        .bank_acct {

            padding: 20px 0 0 0;
            span {
                color: #fff;
                font-size: 26px;
                display: inline-block;
                float: left;
            }
            .van-radio {
                /deep/ .van-radio__icon {
                    .van-icon {
                        width: 30px;
                        height: 30px;
                        font-size: 26px;
                    }
                }
                /deep/ span {
                    color: #fff;
                    margin-left: 5px;
                }
            }

        }
    }
    .logo {
        width: 180px;
        margin-bottom: 20px;
    }

    .checked {
        margin: 20px 0;
        font-size: 22px;

        /deep/ .van-checkbox__icon--round {
            font-size: 28px;

            .van-icon {
                background: #fff;
            }
        }

        /deep/ .van-checkbox__icon--checked {
            .van-icon {
                background: #50AFA7;
                border-color: #fff;
            }
        }

        /deep/ .van-checkbox__label {
            color: #fff;

            a {
                color: #ECE93B;
                margin: 0 8px;
            }
        }
    }

    .but-submit {
        /deep/ .van-button {
            height: 80px;
            line-height: 80px;
            border-radius: 25px;
            color: #9C4826;
            padding: 5px 50px;
            font-size: 30px;
            font-weight: bold;
            border: 0;
        }
    }

    .ku-upload {
        justify-content: center;
        flex: 1;

        .van-uploader {
            padding: 0;
            width: 216px;
            height: 120px;
            float: left;
            &:nth-child(2) {
                margin: 0 8px;
            }
            /deep/ .van-uploader__upload {
                width: 216px;
                height: 120px;
                margin: 0;

                .van-uploader__upload-text {
                    font-size: 24px;
                }
            }

            /deep/ .van-uploader__preview {
                .van-image {
                    width: 216px;
                    height: 120px;
                }
            }
        }
    }

    .popup {
        display: flex;
        height: 30%;
    }

    .popup-content {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
}
</style>
